import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageIcon from '@mui/icons-material/Language';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './LanguageSwitcher.css';

const LanguageSwitcher: React.FC = () => {
  const { i18n, t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    { code: 'en', name: t('language.english'), flag: '🇺🇸' },
    { code: 'es', name: t('language.spanish'), flag: '🇪🇸' }
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const handleLanguageChange = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
    setIsOpen(false);
  };

  return (
    <div className="language-switcher">
      <button
        className="language-switcher-btn"
        onClick={() => setIsOpen(!isOpen)}
        aria-label={`${t('language.switch')} - Current language: ${currentLanguage.name}`}
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        <LanguageIcon sx={{ fontSize: 18, color: '#1a1a2e' }} aria-hidden="true" />
        <span className="current-language">
          {currentLanguage.flag} {currentLanguage.code.toUpperCase()}
        </span>
        <ExpandMoreIcon 
          sx={{ fontSize: 16, color: '#8a8a8a' }} 
          className={`dropdown-arrow ${isOpen ? 'open' : ''}`}
          aria-hidden="true"
        />
      </button>

      {isOpen && (
        <div className="language-dropdown">
          <ul className="language-list" role="menu">
            {languages.map((language) => (
              <li key={language.code}>
                <button
                  className={`language-option ${
                    i18n.language === language.code ? 'active' : ''
                  }`}
                  onClick={() => handleLanguageChange(language.code)}
                  role="menuitem"
                  aria-label={`Switch to ${language.name}`}
                  aria-current={i18n.language === language.code ? 'true' : undefined}
                >
                  <span className="language-flag" aria-hidden="true">{language.flag}</span>
                  <span className="language-name">{language.name}</span>
                  {i18n.language === language.code && (
                    <span className="active-indicator" aria-hidden="true">✓</span>
                  )}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
